<template>
    <div :class="[!bgColor ? 'bg-white' : '']"
         :style="[bgColor ? `background-color: ${bgColor}` : '',
                 fgColor ? `color: ${fgColor}` : '',
                 `padding-top: ${topPadding}px;padding-bottom: ${bottomPadding}px;`]">
        <Container class="px-[18px]">
            <div class="grid gap-8" :class="`grid-cols-1 md:grid-cols-2 lg:grid-cols-${cardsPerRow}`">
                <div v-for="item in items" :key="item.id"
                     class="group text-center p-8 rounded-xl transition-all duration-300 border border-blue-200"
                     :class="{ 'shadow-lg hover:shadow-xl': showShadow }"
                     :style="cardBgColor ? `background-color: ${cardBgColor}` : ''">
                    <div class="block">
<!--                        <div class="w-40 h-40 mx-auto overflow-hidden">-->
                        <div class="flex justify-start">
                                    <img :src="item.image" class="h-15 w-20" alt="Avatar">

<!--                            <img :src="item.image" class="w-40 h-40 object-cover group-hover:scale-105 duration-300" />-->
                        </div>
                        <div class="flex justify-start mt-2">
                            <h3 class="text-lg font-bold text-black">{{ item.heading }}</h3>
                        </div>
                        <div class="flex justify-start">
                            <p class="mt-2 opacity-80 text-gray-700">{{ item.paragraph }}</p>
                        </div>
<!--                        bottom section-->
                        <div class="flex justify-start mt-2">
                            <a :href="item.link" class="text-blue-400">{{ item.link_name }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </div>
</template>

<script>
import Container from '../../../Layouts/Container.vue'

export default {
    components: {
        Container
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        bgColor: {
            type: String,
            default: null
        },
        fgColor: {
            type: String,
            default: '#ffffff'
        },
        cardBgColor: {
            type: String,
            default: null
        },
        topPadding: {
            type: Number,
            default: 50
        },
        bottomPadding: {
            type: Number,
            default: 50
        },
        cardsPerRow: {
            type: Number,
            default: 4
        },
        showShadow: {
            type: Boolean,
            default: false
        }
    }
}
</script>
